var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckedWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\xC9l\\xE9ments",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Element/Notifications/20px_Element"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    className: "st0-fill",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Forme/Arrondi/Rouge"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12,
    cy: 12,
    r: 12
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Icones/Check/Blanc",
    className: "st0-fill",
    transform: "translate(3.000000, 3.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.10170578,14.21309 C6.6806748,14.21309 6.25964381,14.0561526 5.93311277,13.7422778 L2.76905227,10.7047797 C2.09658394,10.0593114 2.07464646,8.99112456 2.7201148,8.31949999 C3.36558314,7.64703166 4.43376997,7.62256293 5.10623829,8.27056252 L7.06711205,10.1529676 L12.8586084,4.25515881 C13.5116705,3.59028423 14.5790136,3.58015923 15.2447319,4.23406507 C15.9096065,4.88712716 15.9197315,5.95531398 15.2666694,6.62018856 L8.30573627,13.7076841 C7.97498648,14.0443401 7.538768,14.21309 7.10170578,14.21309",
    id: "Fill-1"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedWhite);
export default __webpack_public_path__ + "static/media/checked_white.49c9d7672bf956c358ce31543d514a50.svg";
export { ForwardRef as ReactComponent };